import { toast } from 'react-toastify';
import { ReactComponent as Checkmark } from '$icons/uncolored/roundedCheckmark.svg';

const SPKToast = (
  message: string,
  { type = 'Success' }: { type?: 'Success' | 'Error' } = {}
) => {
  toast(
    <div
      className={`${
        type === 'Success' && 'bg-spk-success text-spk-successContrast'
      } ${
        type === 'Error' &&
        'bg-spk-semantic-error text-spk-semantic-errorContrast'
      } flex items-center gap-2 py-2 px-4 font-bold font-mulish`}
    >
      {type === 'Success' && <Checkmark className="fill-spk-successContrast" />}
      {type === 'Error' && (
        <i className="pi pi-exclamation-triangle text-spk-semantic-errorContrast" />
      )}
      {message}
    </div>,
    {
      closeButton: false,
      position: 'top-center',
      hideProgressBar: true,
      className:
        '!p-0 !m-0 !min-h-0 !bg-transparent !shadow-none !w-auto !max-w-auto',
      // To override ToastContainer direction
      style: { direction: 'ltr' },
      autoClose: 5000,
      bodyClassName: '!p-0',
    }
  );

  setTimeout(() => {
    // Workaround to remove width limitation
    const toastContainerElem = document.querySelector(
      '.Toastify__toast-container'
    ) as HTMLDivElement | null;
    if (toastContainerElem) toastContainerElem.style.cssText = `width:auto`;
  }, 100);
};

export default SPKToast;
